// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5600 ? "05f6971a" : chunkId) + "." + {"4565":"a15ab44c442562db","5600":"ad64505f44e190d2","6057":"8920d42f501a7bd1","9709":"5151fda2dc8d4792"}[chunkId] + ".js";
};